(() => {
  if (window.TheoricPdpAccordion) return;

  const ACCORDION_SELECTOR = '.theoric-pdp__accordion-item, .theoric-pdp__inci-details';
  const OPEN_DURATION = 320;
  const CLOSE_DURATION = 260;
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SmoothDetails {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector(':scope > summary');
      this.content = Array.from(details.children).find((child) => child.tagName !== 'SUMMARY');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      if (!this.summary || !this.content) return;

      this.syncAria();
      this.summary.addEventListener('click', this.onClick.bind(this));
      this.details.addEventListener('toggle', () => {
        if (this.isClosing || this.isExpanding) return;
        this.syncAria();
      });
    }

    onClick(event) {
      if (prefersReducedMotion.matches || typeof this.details.animate !== 'function') {
        return;
      }

      event.preventDefault();
      this.details.style.overflow = 'hidden';

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      this.details.classList.add('is-collapsing');

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) this.animation.cancel();

      this.details.style.height = startHeight;
      this.animation = this.details.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: CLOSE_DURATION,
          easing: EASING,
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    open() {
      this.isExpanding = true;
      this.details.classList.remove('is-collapsing');

      const startHeight = `${this.details.offsetHeight}px`;
      this.details.style.height = startHeight;
      this.details.open = true;
      this.syncAria();

      window.requestAnimationFrame(() => {
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.details.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: OPEN_DURATION,
            easing: EASING,
          }
        );

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => {
          this.isExpanding = false;
        };
      });
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.classList.remove('is-collapsing');
      this.details.style.height = '';
      this.details.style.overflow = '';
      this.syncAria();
    }

    syncAria() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    }
  }

  function initializeSmoothAccordions(root = document) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(ACCORDION_SELECTOR).forEach((details) => {
      if (details.dataset.smoothAccordionInitialized === 'true') return;
      details.dataset.smoothAccordionInitialized = 'true';
      new SmoothDetails(details);
    });
  }

  window.TheoricPdpAccordion = {
    init: initializeSmoothAccordions,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSmoothAccordions());
  } else {
    initializeSmoothAccordions();
  }

  document.addEventListener('product-info:loaded', (event) => {
    initializeSmoothAccordions(event.target);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeSmoothAccordions(event.target);
  });
})();

/* ==========================================================================
   Ryse - calculo de frete recolhivel
   O bloco comeca fechado e abre ao clicar no cabecalho "Calcule o frete".
   Se ja houver um CEP/resultado carregado, abre sozinho.
   ========================================================================== */
(() => {
  if (window.TheoricShippingToggle) return;

  const BLOCK_SELECTOR = '.theoric-pdp__shipping-block';
  const HEADER_SELECTOR = '.theoric-pdp__shipping-header';

  function hasSavedResult(block) {
    return Boolean(
      block.querySelector('.shipping-calc__address.is-visible, .shipping-calc__results.is-visible, .shipping-calc__option')
    );
  }

  function initShippingToggle(root = document) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
      if (block.dataset.shippingToggleInitialized === 'true') return;

      const header = block.querySelector(HEADER_SELECTOR);
      if (!header) return;

      block.dataset.shippingToggleInitialized = 'true';
      block.classList.add('is-collapsible');

      if (hasSavedResult(block)) {
        block.classList.add('is-open');
      }

      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', block.classList.contains('is-open') ? 'true' : 'false');

      const toggle = () => {
        const isOpen = block.classList.toggle('is-open');
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
          const input = block.querySelector('.shipping-calc__input');
          if (input) {
            window.requestAnimationFrame(() => input.focus());
          }
        }
      };

      header.addEventListener('click', (event) => {
        if (event.target.closest('a, input, button')) return;
        toggle();
      });

      header.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  window.TheoricShippingToggle = {
    init: initShippingToggle,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShippingToggle());
  } else {
    initShippingToggle();
  }

  document.addEventListener('product-info:loaded', (event) => {
    initShippingToggle(event.target);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initShippingToggle(event.target);
  });
})();
